var map = {
	"./2018-03-04/whats-new.html": 2324,
	"./2018-04-12/whats-new.html": 2325,
	"./2018-04-24/whats-new.html": 2326,
	"./2018-05-23/whats-new.html": 2327,
	"./2018-05-31/whats-new.html": 2328,
	"./2018-07-04/whats-new.html": 2329,
	"./2018-07-19/whats-new.html": 2330,
	"./2018-11-20/whats-new.html": 2331,
	"./2019-04-04/whats-new.html": 2332,
	"./2020-01-21/whats-new.html": 2333,
	"./2020-07-18/whats-new.html": 2334,
	"./2021-06-10/whats-new.html": 2335,
	"./2021-07-26/whats-new.html": 2336,
	"./2021-08-26/whats-new.html": 2337,
	"./2021-12-07/whats-new.html": 2338,
	"./2022-06-03/whats-new.html": 2339,
	"./2022-09-08/whats-new.html": 2340,
	"./2023-01-01/whats-new.html": 2341,
	"./2023-06-14/whats-new.html": 2342,
	"./2024-10-31/whats-new.html": 2343,
	"./2024-12-12/whats-new.html": 2344,
	"./2026-02-04/whats-new.html": 2345
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2323;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2323
// module chunks = 0